import { User } from '../user.model';
export interface CarePlan {
  active?: boolean;
  state?: CarePlanState;
  date_opened?: any;
  date_closed?: any;
  dx_list?: string[];
  id?: string;
  source?: CarePlanInitiator;
  id_patient?: string;
  id_provider?: string;
  problems?: CarePlanProblem[];
  name?: string;
  createdAt?: any;
  updatedAt?: any;
  lastSignoffBy?: string;
  lastSignoffById?: string;
  lastSignoffDate?: string;
  isNew?: boolean;
  idTemp?: string;
  provider?: User;
  /** Transient: serialized form value used to rehydrate a new care plan from a chart draft. */
  draftFormValue?: any;
}

export enum CarePlanState {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  COMPLETED = 'Completed',
}

export interface CarePlanProblem {
  id?: string;
  care_plan_id?: string;
  care_plan_actions?: CarePlanAction[];
  care_plan_notes?: CarePlanNote[];
  care_plan_tasks?: CarePlanTask[];
  source?: CarePlanInitiator;
  problem?: string;
  actions?: CarePlanAction[];
  evaluation?: CarePlanEvaluation;
}

export interface CarePlanEvaluation {
  evaluation: string;
  date: any;
  id?: string;
}

export interface CarePlanAction {
  action_title: string;
  action_type: 'goal' | 'intervention ';
  action_source?: 'welby' | 'mcg';
  date_closed: any;
  date_opened: any;
  id?: string;
  primary_dx: string;
  status: 'open' | 'closed';
  source?: CarePlanInitiator;
  tasks?: CarePlanTask[];
}

export interface CarePlanNote {
  id?: string;
  content?: string;
  cp_task_id?: string;
  cp_action_id?: string;
  date: any;
  createdAt: any;
}

export interface CarePlanTask {
  id?: string;
  cp_action_id: string;
  task_content?: string[];
  task_name?: string;
  task_type?: 'cmp' | 'smp';
  source?: CarePlanInitiator;
  intervention_type?: string;
  notes?: CarePlanNote[];
}

export enum CarePlanInitiator {
  MCG = 'mcg',
  WELBYTEAM = 'welby',
}

export interface ChangedCarePlans {
  id?: string;
  idTemp?: string;
  name?: string;
  value?: CarePlan;
  dirty?: boolean;
  /** Whether the plan's form passes its own required-field checks. */
  valid?: boolean;
}
